export const VIEW_OPTIONS = [
  { id: "currently_frozen", name: "Currently Frozen" },
  { id: "freeze_history", name: "Freeze History" }
];
